import { z } from 'zod'

export type AllKeysRequired<T> = Required<{
  [K in keyof T]: any
}>

export const paramsSchema = z.object({
  page: z.number().int().optional(),
  l: z.string().optional(),
  f: z.string().optional(),
  min_price: z.number().optional(),
  max_price: z.number().optional(),
  d: z.string().optional(), // Date range in format: "date_in,date_out"
  c: z.number().int().optional(),
  a: z.string().optional(),
  cor: z.string().optional(),
  ec: z.literal(1).optional(),
  r: z.string().optional(),
  bo: z.literal(1).optional(),
  sort: z.string().optional(),
  q: z.string().optional(),
  ne: z.string().optional(),
  sw: z.string().optional(),
  of: z.literal(1).optional(),
})

export type paramsType = z.infer<typeof paramsSchema>
export type paramsTypeAllRequired = AllKeysRequired<paramsType>
